/* eslint-disable prefer-const */
import { Tabs } from '@pankod/refine-antd'
import { IResourceComponentsProps } from '@pankod/refine-core'
import { Refunds } from 'interfaces'
import { useTranslation } from 'react-i18next'
import { PendingRefundsList } from './pendingRefunds'
import { ReviewedRefundsList } from './sentRefunds'

export const RefundsList: React.FC<IResourceComponentsProps> = () => {
  const { t } = useTranslation()

  const getColumns = (isReviewed: boolean) => [
    {
      key: 'refund_date',
      title: t('refunds.fields.refundDate'),
      dataIndex: 'refund_date',
      type: 'date',
      filterType: 'date',
      sorter: true
    },
    {
      key: 'refund_number',
      title: t('refunds.fields.refundNumber'),
      dataIndex: 'refund_number',
      filterType: 'select',
      selectType: 'string',
      entity: 'refund_invoice_data',
      label: 'refund_number',
      value: 'refund_number',
      sorter: true,
      selectFilters: [{ field: 'reviewed', operator: 'eq', value: isReviewed }, { field: 'original_order_invoice', operator: 'null', value: 'null' }] // add other filter to show only the refund_invoice_data that has the column original_order_invoice null, to avoid showing the corrections in the refunds list
    },
    {
      key: 'order_id',
      title: t('order.fields.id'),
      dataIndex: 'order_id',
      sorter: true
    },
    {
      key: 'subtotal',
      title: t('refunds.fields.subtotal'),
      dataIndex: 'subtotal'
    },
    {
      key: 'total',
      title: t('refunds.fields.total'),
      dataIndex: 'total'
    },
    {
      key: 'ship_user_name',
      title: t('refunds.fields.shippingUserName'),
      dataIndex: 'ship_user_name'
    },
    {
      key: 'ship_street',
      title: t('refunds.fields.shippingStreet'),
      dataIndex: 'ship_street'
    },
    {
      key: 'ship_pob',
      title: t('refunds.fields.shippingPostalCode'),
      dataIndex: 'ship_pob'
    },
    {
      key: 'ship_phone_number',
      title: t('refunds.fields.shippingPhoneNumber'),
      dataIndex: 'ship_phone_number'
    },
    {
      key: 'bill_user_name',
      title: t('refunds.fields.billingUserName'),
      dataIndex: 'bill_user_name'
    },
    {
      key: 'bill_street',
      title: t('refunds.fields.billingStreet'),
      dataIndex: 'bill_street'
    },
    {
      key: 'bill_pob',
      title: t('refunds.fields.billingPostalCode'),
      dataIndex: 'bill_pob'
    },
    {
      key: 'bill_phone_number',
      title: t('refunds.fields.billingPhoneNumber'),
      dataIndex: 'bill_phone_number'
    },
    {
      key: 'bill_nif',
      title: t('refunds.fields.billingNIF'),
      dataIndex: 'bill_nif'
    }
  ]

  const dataToExport = (refundInvoiceData: any[]) => {
    return refundInvoiceData?.map((data: Refunds) => {
      return {
        [t('refunds.fields.refundDate')]: data.refund_date,
        [t('refunds.fields.refundNumber')]: data.refund_number,
        [t('order.fields.id')]: data.order_id,
        [t('refunds.fields.subtotal')]: data.subtotal,
        [t('refunds.fields.total')]: data.total,
        [t('refunds.fields.shippingUserName')]: data.ship_user_name,
        [t('refunds.fields.shippingStreet')]: data.ship_street,
        [t('refunds.fields.shippingPostalCode')]: data.ship_pob,
        [t('refunds.fields.shippingPhoneNumber')]: data.ship_phone_number,
        [t('refunds.fields.billingUserName')]: data.bill_user_name,
        [t('refunds.fields.billingStreet')]: data.bill_street,
        [t('refunds.fields.billingPostalCode')]: data.bill_pob,
        [t('refunds.fields.billingPhoneNumber')]: data.bill_phone_number,
        [t('refunds.fields.billingNIF')]: data.bill_nif,
        [t('refunds.fields.refundItems')]: data.refund_items
      }
    })
  }

  return (
    <Tabs defaultActiveKey='1' size='middle'>
      <Tabs.TabPane tab={t('refunds.pendingRefunds')} key='1'>
        <PendingRefundsList
          columns={getColumns(false) as any[]}
          dataToExport={dataToExport}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('refunds.reviewedRefunds')} key='2'>
        <ReviewedRefundsList
          columns={getColumns(true) as any[]}
          dataToExport={dataToExport}
        />
      </Tabs.TabPane>
    </Tabs>
  )
}
